import { render, staticRenderFns } from "./AntimatterDimensionsTab.vue?vue&type=template&id=64077ec9&"
import script from "./AntimatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./AntimatterDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports